import { motion } from "framer-motion";
import { SALON_PHOTOS } from "@/data/site";
import SectionLabel from "./SectionLabel";

export default function About() {
  return (
    <section
      id="apropos"
      className="relative py-24 md:py-32 bg-[#F9F6F0] overflow-hidden"
      data-testid="about-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Image collage */}
          <div className="relative">
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.9 }}
              className="relative overflow-hidden rounded-2xl shadow-[0_20px_80px_rgba(28,25,23,0.15)]"
            >
              <img
                src={SALON_PHOTOS.room1}
                alt="Cabine de soin Harmony"
                className="w-full aspect-[4/5] object-cover"
              />
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 40, x: 20 }}
              whileInView={{ opacity: 1, y: 0, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.9, delay: 0.2 }}
              className="absolute -bottom-8 -right-4 md:-right-8 w-2/3 overflow-hidden rounded-2xl border-8 border-[#F9F6F0] shadow-2xl"
            >
              <img
                src={SALON_PHOTOS.reception}
                alt="Espace d'accueil du salon"
                className="w-full aspect-[4/3] object-cover"
              />
            </motion.div>
          </div>

          {/* Text */}
          <div>
            <SectionLabel
              eyebrow="Notre univers"
              title={<>Un écrin<br /><span className="italic text-[#8B5A2B]">à votre image</span></>}
            />
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="space-y-6 text-stone-600 font-light text-base md:text-lg leading-relaxed"
            >
              <p>
                Au cœur de Montélimar, Harmony Massage vous accueille dans un
                espace pensé pour la sérénité. Lumière douce, matières chaleureuses
                et parfums délicats — chaque détail invite au lâcher-prise.
              </p>
              <p>
                Nos soins sont prodigués par une praticienne expérimentée, à
                l'écoute de votre corps et de vos besoins. Chaque rituel se compose
                d'huiles précieuses sélectionnées avec soin.
              </p>
              <div className="grid grid-cols-3 gap-6 pt-6 border-t border-[#E6DFD3]">
                {[
                  { n: "100%", l: "Sur rendez-vous" },
                  { n: "5 soins", l: "Au choix" },
                  { n: "+80", l: "Avis 5 étoiles" },
                ].map((s) => (
                  <div key={s.l}>
                    <p className="font-display text-3xl md:text-4xl text-[#8B5A2B]">
                      {s.n}
                    </p>
                    <p className="text-xs tracking-[0.2em] uppercase text-stone-500 mt-2">
                      {s.l}
                    </p>
                  </div>
                ))}
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}
